import posthog from "posthog-js";

/** Promo links carry `via=<name>`. */
const VIA = "via";

/** Tags every later event from this browser with the promo of a `via` link; the first one wins. */
export function registerVia(): void {
  const via = new URLSearchParams(window.location.search).get(VIA);
  if (via) {
    posthog.register_once({ [VIA]: via });
  }
}

/** The promo this browser came through, if any. */
export function currentVia(): string | undefined {
  const via: unknown = posthog.get_property(VIA);
  return typeof via === "string" && via ? via : undefined;
}

/**
 * Records the promo a new account came through on its PostHog person. Call it once the account
 * exists; an existing user signing in after a promo keeps no `via`.
 */
export function setSignupVia(): void {
  const via = currentVia();
  if (via) {
    posthog.setPersonProperties(undefined, { [VIA]: via });
  }
}
